import { gql } from '@apollo/client'

export const BOOK_APPOINTMENT = gql`
  mutation BookPmsAppointment(
    $availabilitySlotId: ID!
    $date: Date!
    $patient: PatientInput!
    $partnerId: ID
  ) {
    bookPmsAppointment(
      availabilitySlotId: $availabilitySlotId
      date: $date
      patient: $patient
      partnerId: $partnerId
    ) {
      __typename
      ... on PmsBookingIntent {
        id
        start
      }
      ... on AppointmentTimeInvalid {
        message
      }
      ... on AppointmentUnavailable {
        message
      }
      ... on AppointmentLimitReached {
        message
      }
      ... on DayOfWeekMismatch {
        message
      }
      ... on UserInputValidationFailed {
        message
        fieldErrors {
          field
          errors {
            field
            message
          }
        }
      }
    }
  }
`
